export const popLastElementFromUrl = (url?: string) => {
    if(url){
        return url.split('/').slice(0, -1).join('/');
    }
    
    return window.location.pathname.split('/').slice(0, -1).join('/');
}